export const editPatientModalTestSelectors = {
  container: 'edit-patient-modal',
  submitButton: 'edit-patient-modal-submit-button'
};
